import { render, staticRenderFns } from "./Subset.vue?vue&type=template&id=c0c0f48a&scoped=true"
import script from "./Subset.vue?vue&type=script&lang=js"
export * from "./Subset.vue?vue&type=script&lang=js"
import style0 from "./Subset.vue?vue&type=style&index=0&id=c0c0f48a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c0f48a",
  null
  
)

export default component.exports